// extracted by mini-css-extract-plugin
export default {"trigger":"priceStockPopup_trigger__pmvrO","panel":"priceStockPopup_panel__r8lcD"};